import React from 'react';
import './style.scss';

function footer({ children, ...rest }) {
	return (
		<div className="footer" {...rest}>
			{children}
			<div className="footerLineCont">
				<div className="footerLine lightBlue"></div>
				<div className="footerLine darkBlue"></div>
			</div>
		</div>
	);
}
export default footer;
